import API_BASE from './config';

export async function getDrivers() {
    // attempt to fetch from backend API
    try {
        const res = await fetch(`${API_BASE}/drivers`, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('Network error');
        const ct = res.headers.get('content-type') || '';
        if (!ct.includes('application/json')) throw new Error('Non-JSON response');
        const data = await res.json();
        // return raw driver objects so callers can access id, name, first_name, last_name, code, etc.
        return Array.isArray(data) ? data : [];
    } catch (e) {
        console.error('driversApi.getDrivers error', e);
        // fallback to local list
        return [];
    }
}

export function syncDrivers(season = 'current') {
    return fetch(`${API_BASE}/drivers/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ season }),
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to sync drivers');
            return res.json();
        });
}

export function createDriver(firstName, lastName, teamId) {
    return fetch(`${API_BASE}/drivers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ first_name: firstName, last_name: lastName, team_id: teamId }),
    }).then((res) => {
        if (!res.ok) throw new Error('Failed to create driver');
        return res.json();
    });
}

export default { getDrivers, createDriver };
